module.exports = __webpack_public_path__ + "static/media/contract-news-banner.d0fa6465.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/contract-news-banner.png
// module id = 488
// module chunks = 0